/* eslint-disable */
var baseApiUrl = ''
var appBaseUrl = ''
if (process.env.NODE_ENV === 'production') {
  baseApiUrl = 'https://hazard-tool-api.geodemosolutions.com/public/'
  appBaseUrl = 'https://hazard-tool.geodemosolutions.com/#/'
 }
else {
  baseApiUrl = 'http://localhost/hazard-tool-api/public/'
  appBaseUrl = 'http://localhost:5800/#/'
}

export {
  baseApiUrl,
  appBaseUrl
}
